import React from 'react';

import BottomSheet from 'components/BottomSheet';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { ConfirmButton, Container, Title, Text, Link, ButtonContainer, Header, CloseButton, IconClose } from './styles';

interface Props {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}
const FlightsExchangeConfirm = ({ show, onClose, onConfirm, isLoading }: Props) => {
  const { t } = useStoreTranslation();
  return (
    <BottomSheet
      noHeader
      modal
      show={show}
      onClose={onClose}
      style={{ maxHeight: 330, backgroundColor: '#F9F9F9' }}
      zIndex={11}
    >
      <Header>
        <Header.Title>{t('flightsExchange.confirm.header')}</Header.Title>
        <Header.Close>
          <CloseButton onClick={onClose}>
            <IconClose />
          </CloseButton>
        </Header.Close>
      </Header>
      <Container>
        <Title>{t('flightsExchange.confirm.title')}</Title>
        <Text>{t('flightsExchange.confirm.text')}</Text>
        <Link>
          <Link.Text>{t('flightsExchange.confirm.link')}</Link.Text>
          <Link.Arrow />
        </Link>
      </Container>
      <ButtonContainer>
        <ConfirmButton type="button" value="Aceptar" onClick={onConfirm} loading={isLoading} disabled={false} />
      </ButtonContainer>
    </BottomSheet>
  );
};

export default FlightsExchangeConfirm;
